module.exports = __webpack_public_path__ + "media/images/accountSection__settingsClose--dark-df96513d580aca6ce49ffc32f0d87ecf.png";